import React, { useState, useEffect } from 'react';
import GlobalSettings from '../components/GlobalSettings';

export default function AdminAccounts({ ...params }) {
	return (
		<div className="vat-admin-main">
			<GlobalSettings {...params} />
		</div>
	);
}
